import { Link } from "react-router-dom";
import type { EventItem } from "@/mocks/events";

export default function RelatedEvents({ items }: { items: EventItem[] }) {
  if (items.length === 0) return null;
  return (
    <section aria-labelledby="related-heading" className="mt-12">
      <h2 id="related-heading" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        相关档案推荐
      </h2>
      <p className="mt-2 font-body text-sm text-foreground-600">同一分类或相近话题的档案，方便你顺着脉络继续看。</p>
      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {items.map((event) => (
          <Link
            key={event.id}
            to={`/topic/${event.id}`}
            className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-200 hover:border-primary-300"
          >
            <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={event.cover}
                alt={`${event.title} 配图`}
                title={`${event.title} · 相关事件档案`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
              />
            </div>
            <div className="min-w-0">
              <span className="font-label text-xs text-foreground-500">
                {event.categoryName} · {event.date}
              </span>
              <h3 className="mt-1.5 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                {event.title}
              </h3>
              <span className="mt-2 inline-flex items-center gap-1 font-label text-xs text-primary-600">
                查看时间线
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}